import { isMacOS } from "./env";

// 上一张 ArrowUp
export const KEY_ARROWUP = "up";
// 下一张 ArrowDown
export const KEY_ARROWDOWN = "down";
// 上一张 ArrowLeft
export const KEY_ARROWLEFT = "left";
// 下一张 ArrowRight
export const KEY_ARROWRIGHT = "right";

// option + 空格

export const KEY_OPTIONSPACE = isMacOS ? "option+Space" : "shift+Space";
